import React, { Component, useState } from "react";
import { Cards } from "./cardAdmin";
import notifications from "./notifications";
import ReturnSaleBills from "./ReturnSaleBills";

import billtemplates from "./billtemplates";
import LedgerDetails from "./ledgers/LedgerDetails";
import dailyBook from "./daybook/dailyBook";

import VouchersList from "./vouchers/VouchersList";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import purchaseOrdersReturn from "./returnedfinalizedOrders";
import WarehouseBills from "./WarehouseBills";
import EmployeeSalary from "./salary/EmployeeSalary";
import SalaryHistory from "./salary/SalaryHistory";
import WarehouseDetail from "./warehouses/WarehouseDetail";
import Vendors from "./vendors/Vendors";
import FastCash from "./fast cash/FastCash";
import CashDetails from "./fast cash/CashDetails";
import LedgersList from "./ledgers/LedgersList";
import Inventory from "./inventory/Inventory";
import SellItem from "./point of sale/Sell";
import Quotations from "./quotation/Quotations";
import QuotationDetail from "./quotation/QuotationDetails";
import UpdateBill from "./bills/UpdateBill";
import AdminDashboard from "./adminDashboard/AdminDashboard";
import UpdateOrder from "./purchaseOrders/UpdatePurchase";
import Bills from "./bills/Bills";
import OutPurchase from "./purchaseOrders/OutPurchase";
import FinalizedOrders from "./purchaseOrders/FinalizedOrders";
import CompanyProfile from "./company profile/CompanyProfile";
import Invoices from "./invoice/Invoices";
import AddInvoice from "./invoice/AddInvoice";
import Reports from "./reports/Reports";
import CustomerLedgerReport from "./reports/CustomerLedgerReport";
import ExpiredItems from "./expired items/ExpiredItems";
import Racks from "./racks/Racks";
import RackDetails from "./racks/RackDetails";
import Warehouses from "./warehouses/Warehouses";
import SaleReturn from "./saleReturn/saleReturnOrders";
import Vehicles from "./vehicles";
import DailySheet from "./vehicles/DailySheet";
import NoAccess from "./NoAccess";
import { useEffect } from "react";
import EmployeeRoute from "./vehicles/EmployeeRoute";
import UserDetails from "./user details";
import AddSale from "./user details/AddSale";
import SelectItems from "./point of sale/SelectItems";
import Summary from "./summary/Summary";
import Repo from "../Repository/Repo";
import MyStore from "../pages/my store";
import ManageOrders from "../pages/my store/ManageOrders";
import MonthlyChart from "./adminDashboard/charts/MonthlyAnalysis";
import OrderDetails from "../pages/my store/OrderDetails";
import ManageItems from "../pages/my store/ManageItems";
import BankAccounts from "../pages/bank";
import BankDetails from "../pages/bank/BankDetails";
import CashInHand from "../pages/cash in hand";
import Property from "../pages/property";
import AdminSidebar from "../pages/sidebar";
import PurchaseOrders from "./purchaseOrders";
import BarcodePrints from "../pages/barcode";
import Payment from "../pages/payment";
import PaymentDetails from "../pages/payment/PaymentDetails";
import CashInHandDetails from "../pages/cash in hand/CashInHandDetails";

function Admin({ lang, cards }) {
  const location = localStorage.getItem("data")
  console.log('data', location)
  const dynamicPath = `/inventory/admin/inventory${
    location === "SAR" ? "/Pak" : `/${location}`
  }`;
  console.log("  location.country_name,", location);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      fetchTemplate();
    }
  }, []);

  const fetchTemplate = () => {
    Repo.template({
      request: {
        method: "getTemplate",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then(({ data }) => {
      localStorage.setItem("template", data.response.data.template);
    });
  };

  // if (
  //   localStorage.getItem("token") == null ||
  //   localStorage.getItem("tokenType") != "admin"
  // ) {
  //   return <Redirect to="/inventory" />;
  // }

  return (
    <React.Fragment>
      <Router>
        <div className="appgrid component-background">
          <div>
            <AdminSidebar lang={lang} />
          </div>
          <div>
            <Switch>
              <Route
                exact
                path="/inventory/admin/purchase-order/returned=purcahaseorders"
                component={purchaseOrdersReturn}
              />
              <Route exact path="/" component={() => <Cards lang={lang} />} />
              <Route
                exact
                path={`/inventory/${
                  location?.country_code3 === "PAK" ? "" : location?.country_code3
                }`}
                component={() => <Cards lang={lang} />}
              />

              <Route
                exact
                path="/inventory/admin/"
                component={() => <Cards lang={lang} />}
              />
                <Route
                exact
                path="/inventory/admin/items"
                component={() => <Inventory />}
              />
              
              {/* <Route
                exact
                path="/inventory/admin/store/:id/cart"
                component={MonthlyChart}
              /> */}
              <Route
                exact
                path="/inventory/admin/expired-items"
                component={ExpiredItems}
              />
              <Route
                exact
                path="/inventory/admin/payment"
                component={Payment}
              />
              <Route
                exact
                path="/inventory/admin/payment-details"
                component={PaymentDetails}
              />
              <Route
                exact
                path="/inventory/admin/barcode-prints"
                component={BarcodePrints}
              />
              <Route
                exact
                path="/inventory/admin/bank-accounts"
                component={BankAccounts}
              />
              <Route
                exact
                path="/inventory/admin/cashInHand-details"
                component={CashInHandDetails}
              />
              <Route
                exact
                path="/inventory/admin/cash-in-hand"
                component={CashInHand}
              />
              <Route
                exact
                path="/inventory/admin/bank-details"
                component={BankDetails}
              />
              <Route exact path="/inventory/admin/store" component={MyStore} />
              <Route
                exact
                path="/inventory/admin/manage-orders"
                component={ManageOrders}
              />
              <Route
                exact
                path="/inventory/admin/manage-items"
                component={ManageItems}
              />
              <Route
                exact
                path="/inventory/admin/order-details/:id"
                component={OrderDetails}
              />
              <Route
                exact
                path="/inventory/admin/fast-cash"
                component={() => <FastCash />}
              />
              <Route
                exact
                path="/inventory/admin/fast-cash/details"
                component={CashDetails}
              />

              <Route exact path="/inventory/admin/report" component={Reports} />
              <Route
                exact
                path="/inventory/admin/vendors"
                component={Vendors}
              />

              <Route
                exact
                path="/inventory/admin/report/customer-report"
                component={CustomerLedgerReport}
              />

              <Route
                exact
                path="/inventory/admin/employee-salary"
                component={EmployeeSalary}
              />

              <Route
                exact
                path="/inventory/admin/salary-history"
                component={SalaryHistory}
              />

              <Route
                exact
                path="/inventory/admin/summary"
                component={Summary}
              />
              <Route
                exact
                path="/inventory/admin/property"
                component={Property}
              />
              <Route
                exact
                // path={dynamicPath}
               path="/inventory/admin/inventory"
                component={Inventory}
              />
              <Route
                exact
                path="/inventory/admin/vehicles"
                component={Vehicles}
              />
              <Route
                exact
                path="/inventory/admin/user-details"
                component={UserDetails}
              />
              <Route
                exact
                path="/inventory/admin/add-user-details"
                component={AddSale}
              />
              <Route
                exact
                path="/inventory/admin/vehicles-daily-sheet"
                component={DailySheet}
              />
              <Route
                exact
                path="/inventory/admin/employee-route"
                component={EmployeeRoute}
              />

              <Route
                exact
                path="/inventory/admin/outgoing"
                component={SelectItems}
              />
              <Route
                exact
                path="/inventory/admin/notifications"
                component={notifications}
              />
              <Route
                exact
                path="/inventory/admin/company-profile"
                component={CompanyProfile}
              />

              <Route exact path="/inventory/admin/bills" component={Bills} />
              <Route
                exact
                path="/inventory/admin/warehouse-bills"
                component={WarehouseBills}
              />
              <Route
                exact
                path="/inventory/admin/return-bills"
                component={ReturnSaleBills}
              />

              <Route
                exact
                path="/inventory/admin/bills/update-bill"
                component={UpdateBill}
              />
              <Route
                exact
                path="/inventory/admin/outgoing/sell"
                component={SellItem}
              />

              <Route
                exact
                path="/inventory/admin/quotations"
                component={Quotations}
              />
              <Route
                exact
                path="/inventory/admin/quotations/quotation-detail"
                component={QuotationDetail}
              />

              <Route
                exact
                path="/inventory/admin/daily-book"
                component={dailyBook}
              />

              <Route
                exact
                path="/inventory/admin/outgoing/outgoingpurchase"
                component={OutPurchase}
              />
              <Route
                exact
                path="/inventory/admin/purchase-order/updatedOrder"
                component={UpdateOrder}
              />

              <Route
                exact
                path="/inventory/admin/sale-returns"
                component={SaleReturn}
              />
              <Route
                exact
                path="/inventory/admin/purchase-order"
                component={PurchaseOrders}
              />

              <Route
                exact
                path="/inventory/admin/invoices"
                component={Invoices}
              />
              <Route
                exact
                path="/inventory/admin/add-invoice"
                component={AddInvoice}
              />
              <Route
                exact
                path="/inventory/admin/ledgers"
                component={LedgersList}
              />
              {/* <Route
                  exact
                  path="/inventory/admin/bill-template"
                  component={billtemplates}
                /> */}
              <Route
                exact
                path="/inventory/admin/ledgers-details/:id"
                component={LedgerDetails}
              />
              <Route exact path="/inventory/admin/location" component={Racks} />
              <Route
                exact
                path="/inventory/admin/location-details"
                component={RackDetails}
              />
              <Route
                exact
                path="/inventory/admin/vouchers"
                component={VouchersList}
              />

              <Route
                exact
                path="/inventory/admin/purchase-order/finalized"
                component={FinalizedOrders}
              />
              <Route
                exact
                path="/inventory/admin/dashboard"
                component={AdminDashboard}
              />

              <Route
                exact
                path="/inventory/admin/warehouses"
                component={Warehouses}
              />
              <Route
                exact
                path="/inventory/admin/warehouse-detail"
                component={WarehouseDetail}
              />
            </Switch>
          </div>
          <div></div>
        </div>
      </Router>
    </React.Fragment>
  );
}

export default Admin;
